import React from 'react'
import classNames from 'classnames'

import { APIDataBlueUser } from '@evertel/types'
import { formatForSelect } from '@evertel/utils'
import { PeopleSearchSelect } from '@evertel/web/ui'

interface DocumentOwnerProps {
    documentDeptId?: number
    type?: 'label' | 'dropdown'
    selectedOwner?: APIDataBlueUser | null
    onOwnerChange?: (user: APIDataBlueUser) => void
    /** Highlights the owner value as changed vs. the version being compared against (Version History). */
    isChanged?: boolean
    truncate?: boolean
    className?: string
}

const DocumentOwnerDisplay: React.FC<DocumentOwnerProps> = ({
    documentDeptId,
    type = 'label',
    selectedOwner,
    onOwnerChange,
    isChanged,
    truncate,
    className
}) => {

    const handleOwnerChange = (selectedOwner: APIDataBlueUser) => {
        if (onOwnerChange) {
            onOwnerChange(selectedOwner)
        }
    }

    if (type === 'label') {
        const ownerName = selectedOwner
            ? (selectedOwner.firstName?.trim() || selectedOwner.lastName?.trim())
                ? `${selectedOwner.firstName || ''} ${selectedOwner.lastName || ''}`.trim()
                : String(selectedOwner.email || selectedOwner.id || '??????????')
            : 'No Owner'

        return (
            <div className={classNames('d-flex align-items-center', { 'min-width-0': truncate }, className)}>
                <span className={classNames('fw-bold me-2', { 'text-nowrap': truncate })}>Owner:</span>
                <span
                    className={classNames({
                        'bg-warning-subtle rounded-2 px-1': isChanged,
                        'text-truncate': truncate
                    })}
                    title={truncate ? ownerName : undefined}>
                    {ownerName}
                </span>
            </div>
        )
    }

    const formattedOwner = selectedOwner ? formatForSelect([selectedOwner], 'firstName+lastName', 'id', undefined, 'email') : []

    return (
        <div
            className={classNames('d-flex align-items-center me-2', className)}
            style={{ minWidth: 0 }}>
            <span className="fw-bold me-2 text-nowrap">Owner:</span>
            <PeopleSearchSelect
                searchScope="department"
                departmentId={documentDeptId}
                selected={formattedOwner as APIDataBlueUser[]}
                onSelect={handleOwnerChange}
                placeholder="Select owner..."
                menuPlacement="auto"
                styles={{
                    container: (baseStyles) => ({ ...baseStyles, minWidth: 0, flex: 1 }),
                    menu: (baseStyles) => ({ ...baseStyles, width: 'max-content', right: 0})
                }}
            />
        </div>
    )
}

export { DocumentOwnerDisplay }
